import React from 'react';
import { IMarketProps } from './Market.types';
import styles from './Market.module.css';

const Market: React.FC<IMarketProps> = ({ src, alt }: IMarketProps) => (
  <a
    className={styles.storeBtnItem}
    rel="noopener noreferrer"
    target="_blank"
    href={
      alt === 'google'
        ? 'https://play.google.com/store/apps/details?id=com.tsctheory24.app'
        : 'https://apps.apple.com/ch/app/tcs-theorie24/id6740798304'
    }
  >
    <img src={src} alt={alt} />
  </a>
);

export default Market;
